export default "/images/log-in.svg?26463742329bbcff0cc5bfdfc7459026";